import Axios from 'axios'
import {anonymityUrls} from '../urls'

export default {
  get_all_anonymity (context) {
    Axios.get(anonymityUrls.getAllAnonymity).then(function (response) {
      context.commit('GET_ALL_ANONYMITY', response.data)
    })
  }
}
